<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import appConfig from "@/app.config.json";
import Loader from "../components/loader.vue";
import api from "@/axios";
import moment from "moment/moment";
import Swal from "sweetalert2";
import Multiselect from "@vueform/multiselect";
import DropZone from "@/components/widgets/dropZone.vue";
import {ref} from "vue";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Editar Chamado",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {DropZone, Layout, PageHeader, Loader, Multiselect },
  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };
    return { dropzoneFile, drop};
  },
  data() {
    return {

      showModalAnexo: false,
      submittedAnexo: false,
      descranexo: '',
      mediasData: {},
      submittedInteracao: false,
      showFormInteracao: false,
      dtlistPesqChamado: null,
      submmitedChamado: false,
      errosValid: null,
      chamadoData: {
        id: 0,
        setor: 'ST',
        status: 'AB',
        inicio_fmt: moment(new Date()).format('YYYY-MM-DD'),
        fechamento_fmt: moment(new Date()).format('YYYY-MM-DD'),
        satisf: 10,
        progresso: 0,
        prioridade: 0
      },
      chamadoPaiData: null,
      chamadoInteracoesData: null,
      chamadoInteracaoData: {},

      idData: 0,
      updating: true,

      submitted: false,

      title: "Editar Chamado",
      items: [
        {
          text: "Listagem de Chamados",
          href: "/suporte/chamados",
        },
        {
          text: "Editar Chamado",
          active: true,
        },
      ],
    };
  },

  methods: {

    downFile(path, nomeArq){
      console.log('downFile: ' + path)
      //console.log('downFile: ' + path.split('.').pop())
      this.loadingFiles = true
      api.get(`${getBaseUrl()}api/getfile`, {
        responseType: 'blob',
        params: { pathData: path }
      }).then((res) => {
        console.log('res down')
        console.log(res)
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', nomeArq);
        document.body.appendChild(fileLink);
        console.log('fileLink')
        console.log(fileURL)
        fileLink.click();
        this.loadingFiles = false
      })
    },




    delFile(dataID){
      console.log('deletar: ' + dataID)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.loadingFiles = true

          api.delete(`${getBaseUrl()}api/media`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })

            this.loadingFiles = false
            this.mediasData = res.data[0]
          })


        }
      })
    },


    selectedFile(){
      console.log('selectedFile')
      this.dropzoneFile = document.querySelector(".dropzoneFile").files[0]
      console.log('selectedFile')

    },


    confAnexo(){
      console.log('confAnexo')
      this.submittedAnexo = true
      if (this.descranexo !== '' && this.dropzoneFile.name){
        this.showModalAnexo = false
        this.loadingFiles = true

        let arquivo = document.querySelector(".dropzoneFile").files[0]
        console.log(arquivo)
        let formData = new FormData()
        formData.append("iddata", this.idData)
        formData.append("descranexo", this.descranexo)
        formData.append("filename", arquivo.name)
        formData.append("file", arquivo)

        api.post(`${getBaseUrl()}api/chamafile`,formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.mediasData = res.data[0]
          this.loadingFiles = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

        }).catch((err) => {

          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.loadingFiles = false
        })
      }
    },

    novoAnexo(){
      console.log('novoAnexo')
      this.descranexo = ''
      this.submittedAnexo = false
      this.showModalAnexo = true
      this.activeTab = 2
    },


    novaInteracao() {
      console.log('novaInteracao')
      this.showFormInteracao = true

    },


    confInteracao(){
      console.log('confInteracao')
      this.submittedInteracao = true
      this.chamadoInteracaoData.chamado_id = this.idData

      api.post(`${getBaseUrl()}api/chamainte`, {
        interacaoData: this.chamadoInteracaoData
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.showFormInteracao = false
        this.chamadoInteracaoData = {}
        this.carregarDados()
      })


    },


    excluirChamado(){
      console.log('excluirChamado')
      this.showModalChamado = false
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Excluir Chamado (" + this.chamadoData.id + ")",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/chamado`, {
            params: {
              'iddata': this.chamadoData.id
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)




            // this.carregarDados()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })

            this.$router.replace('/suporte/chamados')
          })
        }
      })

    },

    concluirChamado(){
      console.log('concluirChamado')
      this.showModalChamado = false
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Concluir Chamado (" + this.chamadoData.id + ")",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.get(`${getBaseUrl()}api/chamaconcl`, {
            params: {
              'iddata': this.chamadoData.id
            }
          }).then((res) => {
            console.log('then axios confirmar')
            console.log(res)
            this.carregarDados()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações salvas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
          })
        }
      })

    },


    pesqChamado(evt){
      console.log('pesqChamado')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.dtlistPesqChamado = null
        api.get(`${getBaseUrl()}api/chamapesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          // //console.log(res.data.length)
          this.dtlistPesqChamado = res.data
        })
      }
    },


    confChamado() {
      console.log('confChamado')
      console.log(this.chamadoData)
      if (this.chamadoData.id > 0 && this.chamadoData.id === this.chamadoData.chamado_id) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Chamado pai deve ser diferente do chamado em edição",
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        this.submmitedChamado = true
        this.chamadoData.inicio = this.chamadoData.inicio_fmt
        this.chamadoData.fechamento = this.chamadoData.fechamento_fmt
        if (this.chamadoData.titulo && this.chamadoData.setor && this.chamadoData.descricao && this.chamadoData.progresso <= 100) {

          this.updating = true
          api.post(`${getBaseUrl()}api/chamado`, {
            chamadoData: this.chamadoData
          }).then((res) => {
            console.log('then axios')
            console.log(res)
            this.updating = false
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações salvas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })

            if (this.idData === 0){
              this.idData = res.data[0].id
              this.$router.replace('/chamado/editar/' + this.idData)
            }

            this.carregarDados()
          }).catch((err) => {
            console.log('erro axios')
            // console.log(err)
            // console.log(err.response)
            // console.log(err.response.data.errors)
            let erros = err.response.data.errors
            console.log(erros)
            console.log(typeof erros)
            let listaErros = []
            Object.keys(erros).forEach(key => {
              console.log(key, erros[key]);
              listaErros.push({
                'titulo': key,
                'mensagem': erros[key]
              })
            });
            this.errosValid = listaErros
            this.updating = false
          })
        }
      }
    },



    carregarDados(){
      console.log('carregarDados')
      this.updating = true
      if (this.idData > 0){
        api.get(`${getBaseUrl()}api/chamado`, {
          params: { iddata: this.idData }
        }).then((res) => {
          // console.log(res.data)
          if (res.data.error){
            console.log(res.data.error)
            this.$router.push(`/faltapermissao`);
          }else{
            console.log('then axios')
            console.log(res.data)
            this.chamadoData = res.data[0]
            this.chamadoData.inicio_fmt = moment(this.chamadoData.inicio).format('YYYY-MM-DD')
            this.chamadoData.fechamento_fmt = moment(this.chamadoData.fechamento).format('YYYY-MM-DD')
            this.chamadoPaiData = res.data[1]
            if (this.chamadoPaiData && this.chamadoPaiData.id){
              this.dtlistPesqChamado = [
                {
                  'id': this.chamadoPaiData.id,
                  'titulo': this.chamadoPaiData.titulo,
                }
              ]
            }
            this.chamadoInteracoesData = res.data[2]

            if (res.data[3]){
              this.mediasData = res.data[3]
            }


            this.idData = this.chamadoData.id
            this.title = `Editar Chamado (${this.chamadoData.id})`
            this.updating = false
            console.log('finalizou carrega chamado')
          }
        });
      }else{
        this.title = `Criando Novo Chamado`
        this.updating = false
      }
    },



    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    }

  },
  mounted() {
    console.log('mounted_cte_editar_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)

    this.carregarDados()


  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" :status="chamadoData.status" />

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="" >

      <div class="row" v-if="!updating" >

        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex align-items-start">

                <b-button variant="outline-info" class="mx-2" @click="confChamado" v-if="chamadoData.status === 'AB'">
                  <i class="bx bxs-save font-size-16 align-middle me-2"></i>
                  Salvar Alterações
                </b-button>


                <b-button variant="outline-danger" class="mx-2"
                          v-if="chamadoData.id > 0 && chamadoData.status === 'AB'"
                          @click="excluirChamado">
                  <i class="bx bxs-trash font-size-16 align-middle me-2"></i>
                  Excluir Chamado
                </b-button>

                <b-button variant="outline-info" class="mx-2"
                          v-if="chamadoData.id > 0 && chamadoData.status === 'AB'"
                          @click="novaInteracao">
                  <i class="bx bxs-plus-circle font-size-16 align-middle me-2"></i>
                  Nova Interação
                </b-button>

                <b-button variant="outline-warning" class="mx-2"
                          v-if="chamadoData.id > 0"
                          @click="novoAnexo">
                  <i class="bx bxs-plus-circle font-size-16 align-middle me-2"></i>
                  Novo Anexo
                </b-button>


                <b-button type="submit" variant="outline-success" class="mx-2"
                          v-if="chamadoData.id > 0 && chamadoData.status === 'AB'"
                          @click="concluirChamado">
                  <i class="bx bxs-check-circle font-size-16 align-middle me-2"></i>
                  Concluir Chamado
                </b-button>


<!--                <b-button type="submit" variant="success" class="ms-1"-->
<!--                          v-if="chamadoData.status === 'AB'"-->
<!--                          @click="confChamado">-->
<!--                  <i class="bx bx-check-double font-size-16 align-middle me-2"></i>-->
<!--                  Confirmar-->
<!--                </b-button>-->



              </div>
            </div>
          </div>
        </div>

      </div>





      <div v-if="!updating">

        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a
                        v-b-toggle.accordion-1
                        class="text-dark"
                        href="javascript: void(0);"
                    >Dados Principais</a>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-1" visible accordion="my-accordion-1" role="tabpanel">
                  <b-card-body>

                    <div class="row mb-2">


                      <div class="col-md-6" >
                        <label for="codigo">Título</label>
                        <div class="position-relative">
                          <input
                              id="titulo"
                              type="text"
                              v-model="chamadoData.titulo"
                              class="form-control"
                              placeholder="Título"/>
                        </div>
                      </div>


                      <div class="col-md-6">
                        <div class="mb-3">
                          <label for="setor">Setor</label>
                          <select
                              id="setor"
                              v-model="chamadoData.setor"
                              :disabled="chamadoData.status !== 'AB'"
                              class="form-control"
                              :class="{'is-invalid': submmitedChamado && !chamadoData.setor}">
                            <option value="ST">Suporte Técnico</option>
                            <option value="DZ">Desenvolvimento</option>
                          </select>
                          <div v-if="submmitedChamado && !chamadoData.setor" class="invalid-feedback">
                            <span>Campo setor obrigatório, favor preencher.</span>
                          </div>
                        </div>
                      </div>


                    </div>




                    <div class="row mb-2">

                      <div class="col-lg-6">
                        <div class="mb-3">
                          <label for="inicio">Início</label>
                          <input
                              id="inicio"
                              v-model="chamadoData.inicio_fmt"
                              :disabled="chamadoData.status !== 'AB'"
                              type="date"
                              class="form-control"
                              placeholder="Data de Início"/>
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="mb-3">
                          <label for="fechamento">Fechamento</label>
                          <input
                              id="fechamento"
                              v-model="chamadoData.fechamento_fmt"
                              :disabled="chamadoData.status !== 'AB'"
                              type="date"
                              class="form-control"
                              placeholder="Data de fechamento"/>
                        </div>
                      </div>

                    </div>


                    <div class="row mb-2">

                      <div class="col-lg-12">
                        <div class="mb-3">
                          <label for="descricao">Descrição</label>
                          <div class="position-relative">
                            <textarea
                                id="descricao"
                                v-model="chamadoData.descricao"
                                :disabled="chamadoData.status !== 'AB'"
                                type="text"
                                rows="10"
                                class="form-control"
                                placeholder="Descrição completa do ocorrido, URL (endereço de página) nos ajudaria muito... "
                                :class="{'is-invalid': submmitedChamado && !chamadoData.descricao }"/>
                            <div v-if="submmitedChamado && !chamadoData.descricao" class="invalid-feedback">
                              <span>Campo descrição obrigatório, favor preencher.</span>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>


                    <div class="row mb-2">


                      <div class="col-lg-3">
                        <div class="mb-3">
                          <span class="text-primary">Faturamento Parado </span>
                          <b-form-checkbox
                              switch size="lg"
                              value="S"
                              unchecked-value="N"
                              v-model="chamadoData.stsfat"
                              :disabled="chamadoData.status !== 'AB'">
                            {{ chamadoData.stsfat === 'S' ? 'Sim' : 'Não' }}
                          </b-form-checkbox>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label for="progresso">% Evolução (0 - 100)</label>
                          <input
                              id="progresso"
                              v-model="chamadoData.progresso"
                              :disabled="chamadoData.status !== 'AB'"
                              type="number"
                              class="form-control"
                              placeholder="Evolução (%)"
                              :class="{'is-invalid': submmitedChamado && chamadoData.progresso > 100 }"/>
                          <div v-if="submmitedChamado && chamadoData.progresso > 100" class="invalid-feedback">
                            <span>Campo progresso deve ser entre 1 e 100, favor corrigir.</span>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label for="prioridade">% Prioridade (0 - 100)</label>
                          <input
                              id="prioridade"
                              v-model="chamadoData.prioridade"
                              :disabled="chamadoData.status !== 'AB'"
                              type="number"
                              class="form-control"
                              placeholder="Prioridade (%)"
                              :class="{'is-invalid': submmitedChamado && chamadoData.prioridade > 100 }"/>
                          <div v-if="submmitedChamado && chamadoData.prioridade > 100" class="invalid-feedback">
                            <span>Campo prioridade deve ser entre 1 e 100, favor corrigir.</span>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label for="cor">Cor</label>
                          <select
                              id="cor"
                              v-model="chamadoData.cor"
                              :disabled="chamadoData.status !== 'AB'"
                              class="form-control">
                            <option value="blue">Azul</option>
                            <option value="orange">Laranja</option>
                            <option value="green">Verde</option>
                            <option value="red">Vermelho</option>
                          </select>
                        </div>
                      </div>

                    </div>

                    <div class="row mb-2">


                      <div class="col-md-12">
                        <div class="mb-3">
                          <span>Associar a Chamado Pai</span>
                          <multiselect id="chamadoChamadoID"
                                       @search-change="pesqChamado"
                                       v-model="chamadoData.chamado_id"
                                       placeholder="Pesquisar chamado"
                                       :options="dtlistPesqChamado"
                                       :searchable="true"
                                       :disabled="chamadoData.status !== 'AB'"
                                       label="titulo"
                                       class="multiselect-size"
                                       track-by="titulo"
                                       value-prop="id">
                            <template #option="slotProps" v-if="dtlistPesqChamado">
                              <div class="row">
                                <div>
                                  <span class="text-info">
                                    {{ slotProps.option.id }}
                                  </span>
                                  <span class="mx-4" >
                                    {{ slotProps.option.titulo }}
                                  </span>
                                </div>
                                <div>
                                </div>

                              </div>
                            </template>
                          </multiselect>
                        </div>
                      </div>


                    </div>



                  </b-card-body>
                </b-collapse>
              </b-card>

            </div>
          </div>
        </div>


        <b-card-text>
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a
                        v-b-toggle.accordion-9
                        class="text-dark"
                        href="javascript: void(0);"
                    >Interações</a>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-9" visible accordion="my-accordion-9" role="tabpanel">
                  <b-card-body>

                    <div class="table-responsive mb-2">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>

                          <th scope="col">ID</th>
                          <th scope="col">Usuário</th>
                          <th scope="col">Descrição</th>
                          <th scope="col" class="text-end">Data</th>

                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="item in chamadoInteracoesData" :key="item.id">

                          <td class="text-muted mb-0">{{ item.id }}</td>
                          <td class="text-muted mb-0">
                            <span>{{ item.created_by }}</span>
                            <i class="bx bxs-user-detail font-size-18 bx-fade-right text-warning" v-if="item.cnpjremet"></i>
                          </td>

                          <td class="text-muted mb-0 text-start text-wrap" style="min-width: 50%">
                            <span>{{ item.descricao }}</span>
                          </td>

                          <td class="text-muted mb-0 text-end">{{ formatDateTime(item.created_at) }}</td>

                        </tr>

                        </tbody>
                      </table>
                    </div>

                  </b-card-body>
                </b-collapse>
              </b-card>

            </div>
          </div>

        </b-card-text>



        <b-card-text>
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a
                        v-b-toggle.accordion-10
                        class="text-dark"
                        href="javascript: void(0);"
                    >Anexos</a>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-10" visible accordion="my-accordion-10" role="tabpanel">
                  <b-card-body>

                    <div class="table-responsive" v-if="!updating">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Descrição</th>
                          <th scope="col">Arquivo</th>
                          <th scope="col">Data</th>
                          <th scope="col">Ações</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="data in mediasData" :key="data.id">

                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.id }}
                              </span>
                            </h5>
                          </td>

                          <td>
                            {{ data.descricao }}
                          </td>

                          <td>
                        <span class="text-dark">
                          {{ data.nome }}
                        </span>
                          </td>

                          <td>
                            <h5 class="font-size-14 text-truncate">
                          <span class="text-dark">
                            {{ formatDateTime(data.created_at) }}
                          </span>
                            </h5>
                          </td>


                          <td>
                            <div class="button-items">

                              <b-button variant="outline-success" @click="downFile(data.path, data.nome)">
                                <i class="mdi mdi-download d-block font-size-16"></i>
                              </b-button>

<!--                              <b-button variant="outline-danger" @click="delFile(data.id)" :disabled="data.email === 'admin@admin.com.br'">-->
<!--                                <i class="mdi mdi-trash-can d-block font-size-16"></i>-->
<!--                              </b-button>-->

                            </div>
                          </td>


                        </tr>

                        </tbody>
                      </table>
                    </div>

                  </b-card-body>
                </b-collapse>
              </b-card>

            </div>
          </div>

        </b-card-text>





      </div>

    </div>


    <b-modal  size="lg"
              title="Criar nova interação para chamado" v-model="showFormInteracao" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">

            <form class="needs-validation">
              <div class="row">


                <div class="col-lg-12">
                  <div class="mb-3">
                    <label for="descricao">Descrição</label>
                    <div class="position-relative">
                  <textarea
                      id="descricao"
                      v-model="chamadoInteracaoData.descricao"
                      type="text"
                      rows="10"
                      class="form-control"
                      placeholder="Descrição"
                      :class="{'is-invalid': submittedInteracao && !chamadoInteracaoData.descricao }"/>
                      <div v-if="submittedInteracao && !chamadoInteracaoData.descricao" class="invalid-feedback">
                        <span>Campo descrição obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>
                </div>



              </div>

              <div class="row">

                <div class="text-end mt-5">
                  <b-button variant="light" @click="showFormInteracao = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Cancelar
                  </b-button>
                  <b-button type="button" variant="success" class="ms-1" @click="confInteracao">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>

              </div>

            </form>

          </div>
        </div>
      </div>
    </b-modal>




    <b-modal title="Criar Novo Anexo" v-model="showModalAnexo" centered hide-footer>
      <div>

        <div class="card-body">
          <h4 class="card-title">Selecionar novo arquivo</h4>
          <DropZone @change="selectedFile" />
          <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
          <div v-if="submittedAnexo && !dropzoneFile.name" >
            <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <label for="descranexo">Descrição</label>
              <div class="position-relative">
                <input
                    id="descranexo"
                    type="text"
                    v-model="descranexo"
                    class="form-control"
                    placeholder="Descrição do anexo"
                    :class="{'is-invalid': submittedAnexo && !descranexo}"/>
                <div v-if="submittedAnexo && !descranexo" class="invalid-feedback">
                  <span>Campo descrição obrigatório, favor preencher.</span>
                </div>

              </div>
            </div>
          </div>
        </div>


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalAnexo = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confAnexo">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>



  </Layout>
</template>
